// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.liberation-page {
  min-height: 100vh;
}

.liberation-container {
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
  max-width: none;
}

.liberation-progress-card {
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-md);
  box-shadow: var(--ui-shadow-sm);
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.liberation-progress-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.liberation-progress-header strong {
  font-size: 13px;
  color: var(--ui-text);
}

.liberation-progress-header span {
  font-size: 12px;
  color: var(--ui-primary);
  font-weight: 700;
}

.liberation-progress-track {
  height: 8px;
  border-radius: 999px;
  background: #e9effa;
  overflow: hidden;
}

.liberation-progress-fill {
  height: 100%;
  border-radius: 999px;
  background: var(--ui-primary);
  transition: width 0.2s ease;
}

.liberation-progress-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
}

.liberation-progress-meta span {
  font-size: 11px;
  color: var(--ui-muted);
}

.liberation-hero {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  padding: 22px 24px;
  border-radius: 18px;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
}

.liberation-hero-overline {
  margin: 0 0 4px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--ui-primary);
  font-size: 12px;
  font-weight: 700;
}

.liberation-hero h2 {
  margin: 0 0 8px;
  font-size: 30px;
  line-height: 1.1;
  color: var(--ui-text);
}

.liberation-hero span {
  display: block;
  color: var(--ui-muted);
  font-size: 14px;
  max-width: none;
}

.liberation-search-inline {
  margin-bottom: 12px;
}

.liberation-search-inline .search-container {
  width: 100%;
}

.liberation-search-inline .search-row {
  max-width: 920px;
}

.liberation-search-inline .search-select {
  flex: 0 0 140px;
  height: 50px;
}

.liberation-search-inline .search-wrapper {
  min-width: 520px;
}

.liberation-search-inline .search-wrapper input {
  height: 50px;
  font-size: 16px;
}

.liberation-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  align-items: stretch;
}

.liberation-form > * {
  width: 100%;
}

.liberation-block {
  background: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-lg);
  padding: 18px;
  box-shadow: var(--ui-shadow-sm);
}

.liberation-block-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.liberation-block-title > span {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--ui-primary);
  color: var(--ui-primary-contrast);
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.liberation-block-title h3 {
  margin: 0;
  font-size: 18px;
  color: var(--ui-text);
}

.liberation-block-title p {
  margin: 2px 0 0;
  color: var(--ui-muted);
  font-size: 13px;
}

.liberation-internal-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px;
  border-radius: 14px;
  border: 1px dashed var(--ui-border);
  background: var(--ui-input-bg);
}

.liberation-internal-card.selected {
  border-style: solid;
  border-color: var(--ui-primary);
  background: #f5f8ff;
}

.liberation-internal-avatar {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: #e8f0ff;
  color: var(--ui-primary);
  font-size: 22px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.liberation-internal-avatar.small {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  font-size: 18px;
}

.liberation-internal-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.liberation-internal-meta strong {
  font-size: 16px;
  color: var(--ui-text);
}

.liberation-internal-meta span {
  font-size: 12px;
  color: var(--ui-muted);
}

.liberation-batch-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 420px;
  overflow-y: scroll;
  scrollbar-gutter: stable;
  padding-right: 4px;
}

.liberation-batch-list::-webkit-scrollbar {
  width: 10px;
}

.liberation-batch-list::-webkit-scrollbar-track {
  background: #eef3fb;
  border-radius: 999px;
}

.liberation-batch-list::-webkit-scrollbar-thumb {
  background: #b8c7de;
  border-radius: 999px;
}

.liberation-batch-item {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(260px, 1fr) auto;
  align-items: end;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid var(--ui-border);
  border-radius: 10px;
  background: var(--ui-surface);
}

.liberation-batch-item-main {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.liberation-batch-item-doc {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.liberation-batch-item-doc label {
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 600;
  color: var(--ui-muted);
  letter-spacing: 0.02em;
}

.liberation-hidden-file-input {
  display: none;
}

.liberation-file-trigger-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 34px;
  border: 1px solid var(--ui-border);
  border-radius: 9px;
  background: var(--ui-input-bg);
  padding: 4px 8px;
}

.liberation-file-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  padding: 0 10px;
  border-radius: 7px;
  border: 1px solid #c6d5ec;
  background: #ffffff;
  color: #3f5f92;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.liberation-file-trigger:hover {
  background: #f6f9ff;
}

.liberation-file-name {
  font-size: 11px;
  color: var(--ui-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.liberation-file-name.selected {
  color: var(--ui-text);
}

.liberation-remove-btn {
  background: #fffafa;
  border: 1px solid #f3d5d5;
  color: #af4a4a;
  min-height: 30px;
  max-height: none;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  align-self: center;
}

.liberation-remove-btn:hover:not(:disabled) {
  background: #fff0f0;
}

.liberation-batch-empty {
  border: 1px dashed var(--ui-border);
  border-radius: 12px;
  background: var(--ui-input-bg);
  color: var(--ui-muted);
  font-size: 13px;
  padding: 10px 12px;
}

.liberation-monitoring-alert {
  margin-bottom: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #d33b3b;
  background: #fdeaea;
  color: #a02020;
  font-size: 13px;
  line-height: 1.5;
  animation: liberationAlertBlink 0.6s ease-in-out 2;
}

.liberation-monitoring-alert strong {
  color: #a02020;
}

@keyframes liberationAlertBlink {
  0%, 100% {
    background: #fdeaea;
    border-color: #d33b3b;
  }
  50% {
    background: #f8b9b9;
    border-color: #a02020;
  }
}

.liberation-type-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;
}

.liberation-type-card {
  border: 1px solid var(--ui-border);
  border-radius: 12px;
  background: var(--ui-surface);
  padding: 12px;
  text-align: left;
  cursor: pointer;
  transition: all 0.18s ease;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 4px;
  max-height: none;
  min-height: 84px;
  height: auto;
}

.liberation-type-card strong {
  color: var(--ui-text);
  font-size: 14px;
  line-height: 1.2;
  white-space: normal;
}

.liberation-type-card span {
  color: var(--ui-muted);
  font-size: 12px;
  line-height: 1.25;
  white-space: normal;
}

.liberation-type-card:hover {
  border-color: var(--ui-primary);
  transform: translateY(-1px);
  background: var(--ui-input-bg);
}

.liberation-type-card.active {
  background: var(--ui-input-bg);
  border-color: var(--ui-primary);
  box-shadow: 0 0 0 1px rgba(3, 78, 162, 0.15);
}

.liberation-fields-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.liberation-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.liberation-field label {
  font-size: 12px;
  letter-spacing: 0.03em;
  font-weight: 700;
  color: var(--ui-primary);
  text-transform: uppercase;
}

.liberation-field input,
.liberation-field select {
  height: 42px;
  border-radius: 10px;
  border: 1px solid var(--ui-border);
  background: var(--ui-surface);
  padding: 0 12px;
  color: var(--ui-text);
}

.liberation-field input:focus,
.liberation-field select:focus {
  border-color: var(--ui-primary);
  outline: none;
  box-shadow: 0 0 0 3px rgba(3, 78, 162, 0.14);
}

.liberation-field.full-width {
  grid-column: 1 / -1;
}

.liberation-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.liberation-cancel-btn,
.liberation-save-btn {
  border: none;
  border-radius: 10px;
  padding: 11px 18px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.18s ease;
}

.liberation-cancel-btn {
  color: var(--ui-primary);
  background: var(--ui-surface);
  border: 1px solid var(--ui-primary);
}

.liberation-cancel-btn:hover:not(:disabled) {
  background: #f3f7ff;
}

.liberation-save-btn {
  color: var(--ui-primary-contrast);
  background: var(--ui-primary);
  min-width: 170px;
}

.liberation-save-btn:hover:not(:disabled) {
  filter: brightness(1.03);
  transform: translateY(-1px);
}

.liberation-cancel-btn:disabled,
.liberation-save-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.liberation-help-text {
  font-size: 12px;
  color: var(--ui-muted);
  padding-left: 2px;
}

@media (max-width: 980px) {
  .liberation-hero {
    flex-direction: column;
    align-items: flex-start;
  }

  .liberation-fields-grid {
    grid-template-columns: 1fr;
  }

  .liberation-search-inline .search-wrapper {
    min-width: 0;
  }
}

@media (max-width: 640px) {
  .liberation-hero h2 {
    font-size: 24px;
  }

  .liberation-block {
    padding: 14px;
  }

  .liberation-actions {
    flex-direction: column-reverse;
  }

  .liberation-batch-item {
    grid-template-columns: 1fr;
    align-items: stretch;
    gap: 6px;
  }

  .liberation-batch-item-main {
    width: 100%;
  }

  .liberation-file-trigger-row {
    width: 100%;
  }

  .liberation-remove-btn {
    width: auto;
    justify-content: flex-start;
    align-self: flex-start;
  }

  .liberation-save-btn,
  .liberation-cancel-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Internos/liberation.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;EACjC,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,iEAAiE;EACjE,gBAAgB;EAChB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,6BAA6B;EAC7B,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,+BAA+B;EAC/B,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".liberation-page {\n  min-height: 100vh;\n}\n\n.liberation-container {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  width: 100%;\n  max-width: none;\n}\n\n.liberation-progress-card {\n  background: var(--ui-surface);\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-md);\n  box-shadow: var(--ui-shadow-sm);\n  padding: 10px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.liberation-progress-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.liberation-progress-header strong {\n  font-size: 13px;\n  color: var(--ui-text);\n}\n\n.liberation-progress-header span {\n  font-size: 12px;\n  color: var(--ui-primary);\n  font-weight: 700;\n}\n\n.liberation-progress-track {\n  height: 8px;\n  border-radius: 999px;\n  background: #e9effa;\n  overflow: hidden;\n}\n\n.liberation-progress-fill {\n  height: 100%;\n  border-radius: 999px;\n  background: var(--ui-primary);\n  transition: width 0.2s ease;\n}\n\n.liberation-progress-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 14px;\n}\n\n.liberation-progress-meta span {\n  font-size: 11px;\n  color: var(--ui-muted);\n}\n\n.liberation-hero {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 22px 24px;\n  border-radius: 18px;\n  background: var(--ui-surface);\n  border: 1px solid var(--ui-border);\n}\n\n.liberation-hero-overline {\n  margin: 0 0 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--ui-primary);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.liberation-hero h2 {\n  margin: 0 0 8px;\n  font-size: 30px;\n  line-height: 1.1;\n  color: var(--ui-text);\n}\n\n.liberation-hero span {\n  display: block;\n  color: var(--ui-muted);\n  font-size: 14px;\n  max-width: none;\n}\n\n.liberation-search-inline {\n  margin-bottom: 12px;\n}\n\n.liberation-search-inline .search-container {\n  width: 100%;\n}\n\n.liberation-search-inline .search-row {\n  max-width: 920px;\n}\n\n.liberation-search-inline .search-select {\n  flex: 0 0 140px;\n  height: 50px;\n}\n\n.liberation-search-inline .search-wrapper {\n  min-width: 520px;\n}\n\n.liberation-search-inline .search-wrapper input {\n  height: 50px;\n  font-size: 16px;\n}\n\n.liberation-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n  align-items: stretch;\n}\n\n.liberation-form > * {\n  width: 100%;\n}\n\n.liberation-block {\n  background: var(--ui-surface);\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-lg);\n  padding: 18px;\n  box-shadow: var(--ui-shadow-sm);\n}\n\n.liberation-block-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.liberation-block-title > span {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: var(--ui-primary);\n  color: var(--ui-primary-contrast);\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.liberation-block-title h3 {\n  margin: 0;\n  font-size: 18px;\n  color: var(--ui-text);\n}\n\n.liberation-block-title p {\n  margin: 2px 0 0;\n  color: var(--ui-muted);\n  font-size: 13px;\n}\n\n.liberation-internal-card {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px;\n  border-radius: 14px;\n  border: 1px dashed var(--ui-border);\n  background: var(--ui-input-bg);\n}\n\n.liberation-internal-card.selected {\n  border-style: solid;\n  border-color: var(--ui-primary);\n  background: #f5f8ff;\n}\n\n.liberation-internal-avatar {\n  width: 46px;\n  height: 46px;\n  border-radius: 12px;\n  background: #e8f0ff;\n  color: var(--ui-primary);\n  font-size: 22px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.liberation-internal-avatar.small {\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  font-size: 18px;\n}\n\n.liberation-internal-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.liberation-internal-meta strong {\n  font-size: 16px;\n  color: var(--ui-text);\n}\n\n.liberation-internal-meta span {\n  font-size: 12px;\n  color: var(--ui-muted);\n}\n\n.liberation-batch-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 420px;\n  overflow-y: scroll;\n  scrollbar-gutter: stable;\n  padding-right: 4px;\n}\n\n.liberation-batch-list::-webkit-scrollbar {\n  width: 10px;\n}\n\n.liberation-batch-list::-webkit-scrollbar-track {\n  background: #eef3fb;\n  border-radius: 999px;\n}\n\n.liberation-batch-list::-webkit-scrollbar-thumb {\n  background: #b8c7de;\n  border-radius: 999px;\n}\n\n.liberation-batch-item {\n  display: grid;\n  grid-template-columns: minmax(220px, 1fr) minmax(260px, 1fr) auto;\n  align-items: end;\n  gap: 8px;\n  padding: 8px 10px;\n  border: 1px solid var(--ui-border);\n  border-radius: 10px;\n  background: var(--ui-surface);\n}\n\n.liberation-batch-item-main {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.liberation-batch-item-doc {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.liberation-batch-item-doc label {\n  font-size: 10px;\n  text-transform: uppercase;\n  font-weight: 600;\n  color: var(--ui-muted);\n  letter-spacing: 0.02em;\n}\n\n.liberation-hidden-file-input {\n  display: none;\n}\n\n.liberation-file-trigger-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 34px;\n  border: 1px solid var(--ui-border);\n  border-radius: 9px;\n  background: var(--ui-input-bg);\n  padding: 4px 8px;\n}\n\n.liberation-file-trigger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  padding: 0 10px;\n  border-radius: 7px;\n  border: 1px solid #c6d5ec;\n  background: #ffffff;\n  color: #3f5f92;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.liberation-file-trigger:hover {\n  background: #f6f9ff;\n}\n\n.liberation-file-name {\n  font-size: 11px;\n  color: var(--ui-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.liberation-file-name.selected {\n  color: var(--ui-text);\n}\n\n.liberation-remove-btn {\n  background: #fffafa;\n  border: 1px solid #f3d5d5;\n  color: #af4a4a;\n  min-height: 30px;\n  max-height: none;\n  padding: 4px 10px;\n  border-radius: 8px;\n  font-size: 11px;\n  font-weight: 600;\n  align-self: center;\n}\n\n.liberation-remove-btn:hover:not(:disabled) {\n  background: #fff0f0;\n}\n\n.liberation-batch-empty {\n  border: 1px dashed var(--ui-border);\n  border-radius: 12px;\n  background: var(--ui-input-bg);\n  color: var(--ui-muted);\n  font-size: 13px;\n  padding: 10px 12px;\n}\n\n.liberation-monitoring-alert {\n  margin-bottom: 12px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  border: 1px solid #d33b3b;\n  background: #fdeaea;\n  color: #a02020;\n  font-size: 13px;\n  line-height: 1.5;\n  animation: liberationAlertBlink 0.6s ease-in-out 2;\n}\n\n.liberation-monitoring-alert strong {\n  color: #a02020;\n}\n\n@keyframes liberationAlertBlink {\n  0%, 100% {\n    background: #fdeaea;\n    border-color: #d33b3b;\n  }\n  50% {\n    background: #f8b9b9;\n    border-color: #a02020;\n  }\n}\n\n.liberation-type-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 10px;\n}\n\n.liberation-type-card {\n  border: 1px solid var(--ui-border);\n  border-radius: 12px;\n  background: var(--ui-surface);\n  padding: 12px;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.18s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 4px;\n  max-height: none;\n  min-height: 84px;\n  height: auto;\n}\n\n.liberation-type-card strong {\n  color: var(--ui-text);\n  font-size: 14px;\n  line-height: 1.2;\n  white-space: normal;\n}\n\n.liberation-type-card span {\n  color: var(--ui-muted);\n  font-size: 12px;\n  line-height: 1.25;\n  white-space: normal;\n}\n\n.liberation-type-card:hover {\n  border-color: var(--ui-primary);\n  transform: translateY(-1px);\n  background: var(--ui-input-bg);\n}\n\n.liberation-type-card.active {\n  background: var(--ui-input-bg);\n  border-color: var(--ui-primary);\n  box-shadow: 0 0 0 1px rgba(3, 78, 162, 0.15);\n}\n\n.liberation-fields-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.liberation-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.liberation-field label {\n  font-size: 12px;\n  letter-spacing: 0.03em;\n  font-weight: 700;\n  color: var(--ui-primary);\n  text-transform: uppercase;\n}\n\n.liberation-field input,\n.liberation-field select {\n  height: 42px;\n  border-radius: 10px;\n  border: 1px solid var(--ui-border);\n  background: var(--ui-surface);\n  padding: 0 12px;\n  color: var(--ui-text);\n}\n\n.liberation-field input:focus,\n.liberation-field select:focus {\n  border-color: var(--ui-primary);\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(3, 78, 162, 0.14);\n}\n\n.liberation-field.full-width {\n  grid-column: 1 / -1;\n}\n\n.liberation-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.liberation-cancel-btn,\n.liberation-save-btn {\n  border: none;\n  border-radius: 10px;\n  padding: 11px 18px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.18s ease;\n}\n\n.liberation-cancel-btn {\n  color: var(--ui-primary);\n  background: var(--ui-surface);\n  border: 1px solid var(--ui-primary);\n}\n\n.liberation-cancel-btn:hover:not(:disabled) {\n  background: #f3f7ff;\n}\n\n.liberation-save-btn {\n  color: var(--ui-primary-contrast);\n  background: var(--ui-primary);\n  min-width: 170px;\n}\n\n.liberation-save-btn:hover:not(:disabled) {\n  filter: brightness(1.03);\n  transform: translateY(-1px);\n}\n\n.liberation-cancel-btn:disabled,\n.liberation-save-btn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.liberation-help-text {\n  font-size: 12px;\n  color: var(--ui-muted);\n  padding-left: 2px;\n}\n\n@media (max-width: 980px) {\n  .liberation-hero {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .liberation-fields-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .liberation-search-inline .search-wrapper {\n    min-width: 0;\n  }\n}\n\n@media (max-width: 640px) {\n  .liberation-hero h2 {\n    font-size: 24px;\n  }\n\n  .liberation-block {\n    padding: 14px;\n  }\n\n  .liberation-actions {\n    flex-direction: column-reverse;\n  }\n\n  .liberation-batch-item {\n    grid-template-columns: 1fr;\n    align-items: stretch;\n    gap: 6px;\n  }\n\n  .liberation-batch-item-main {\n    width: 100%;\n  }\n\n  .liberation-file-trigger-row {\n    width: 100%;\n  }\n\n  .liberation-remove-btn {\n    width: auto;\n    justify-content: flex-start;\n    align-self: flex-start;\n  }\n\n  .liberation-save-btn,\n  .liberation-cancel-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
